import React from "react";
//
import { Link } from "react-router-dom";

type MightierLinkProps = React.ComponentProps<typeof Link>;

export const MightierLink = React.memo<MightierLinkProps>((props) => {
  return <Link {...props} className={`text-base font-medium underline ${props.className ?? ""}`} />;
});

MightierLink.displayName = "MightierLink";
